var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary custom-btn",staticStyle:{"white-space":"nowrap"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('clicked');}}},[(_vm.processing)?[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n    Loading..\n    ")]:[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }